import type { FC } from "react";

import clsx from "clsx";

import { useViewportInfoContext } from "@/src/contexts";
import * as stylex from "@stylexjs/stylex";

import { type QueryXsMax } from "../../styles/tokens.stylex";
import type { ICashbackDetails } from "../cashback/CashbackDetails";
import CashbackDetails from "../cashback/CashbackDetails";
import type { ILogoTile } from "../common/LogoTile";
import LogoTile from "../common/LogoTile";
import WebpageLink from "../common/links/WebpageLink";

import * as css from "./BrandDetailsHeader.module.css";

export interface IBrandDetailsHeader {
    id: string;
    name: string;
    seoName: string;
    cashbackDetails?: ICashbackDetails;
    description: string;
    details: string;
    logo: ILogoTile;
    websiteLink?: string;
    changeBrandFollowed?: (isBrandFollowed: boolean) => void;
    showNewsletterSignupItem: boolean;
}

export const BrandDetailsHeader: FC<IBrandDetailsHeader> = (props) => {
    const { isMobile } = useViewportInfoContext();

    const actionsContainer = props.websiteLink && (
        <WebpageLink href={props.websiteLink} styleX={styles.link} />
    );

    return (
        <div className={css.brandDetailsHeaderComponent}>
            <div className={clsx(css.headContent, props.cashbackDetails && css.cashbackInfo)}>
                <div className={css.content}>
                    <LogoTile {...props.logo} className={css.brandLogo} type="brands" />
                    <div className={css.brandData}>
                        {props.name && <h1 className={css.brandName}>{props.name}</h1>}
                        {props.details && <span className={css.details}>{props.details}</span>}
                        {!isMobile && (
                            <>
                                <br />
                                {actionsContainer}
                            </>
                        )}
                    </div>
                    {isMobile && actionsContainer}
                </div>
            </div>
            {props.cashbackDetails && (
                <CashbackDetails
                    {...props.cashbackDetails}
                    brandId={props.id}
                    brandName={props.name}
                    logoUrl={props.logo.logo.src}
                />
            )}
        </div>
    );
};

const xsMax: QueryXsMax = "@media (max-width: 759px)";

const styles = stylex.create({
    link: {
        fontSize: { default: "1rem", [xsMax]: ".875rem" },
        fontWeight: 300,
        textTransform: "uppercase",
        marginBottom: { default: 20, [xsMax]: 0 },
        marginTop: 20,
    },
});
